import { createSlice } from "@reduxjs/toolkit";


interface AdminUserListProps {
    challanListData: [],
    needToRefresh: boolean
}

const initialState: AdminUserListProps = {
  challanListData: [],
  needToRefresh: false
};


const adminChallanlist = createSlice({
  name: "AdminChallanList",
  initialState,
  reducers: {
    setChallanListData(state, action) {
      state. challanListData = action.payload;
    },
    setIsNeedRefresh(state, action) {
      state.needToRefresh = action.payload;
    }
  },
});

export default adminChallanlist.reducer;

export const { setChallanListData,setIsNeedRefresh } = adminChallanlist.actions;
